
import { defineComponent } from "vue";
import { VSlideGroup } from "vuetify/lib";

export default defineComponent({
  mixins: [VSlideGroup],
  props: {
    showArrows: {
      type: [Boolean, String],
      default: "desktop",
    },
  },
});
